module.exports = __webpack_public_path__ + "img/center44.23b5c3f7.png";